import React, { useEffect } from 'react';

function CrossIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 10 10"
            fill="none"
        >
            <path
                d="M6.0363 4.99925L9.07029 1.96526C9.20906 1.82731 9.28578 1.64284 9.28578 1.44694C9.28578 1.25104 9.20906 1.06738 9.07029 0.928621C8.7944 0.651912 8.31118 0.65028 8.03366 0.928621L4.99966 3.96262L1.96566 0.928621C1.67998 0.642934 1.21472 0.642934 0.929029 0.928621C0.643342 1.21431 0.643342 1.67875 0.929029 1.96526L3.96303 4.99925L0.929029 8.03325C0.790267 8.17201 0.714355 8.35648 0.714355 8.55157C0.714355 8.74747 0.790267 8.93194 0.929029 9.06989C1.20655 9.34823 1.69059 9.34659 1.96566 9.06989L4.99966 6.03589L8.03366 9.06989C8.17242 9.20865 8.35689 9.28538 8.55198 9.28538C8.74788 9.28538 8.93316 9.20865 9.07029 9.06989C9.20906 8.93194 9.28578 8.74747 9.28578 8.55238C9.28578 8.3573 9.20906 8.17201 9.07029 8.03325L6.0363 4.99925Z"
                fill="currentColor"
            />
        </svg>
    );
}
function MessageTemplate({ message, setMessage }) {
    const handleClose = () => {
        setMessage(null);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setMessage(null);
        }, message?.timeout || 6000);

        return () => {
            clearTimeout(timer);
        };
    }, [message, setMessage]);

    if (!message) {
        return null;
    }

    return (
        <div
            className={`fixed right-3 md:right-12 bottom-3 md:bottom-11 w-68 md:w-88 rounded-md md:rounded-xl text-white p-2.5 min-[50px] z-[2001] flex justify-between items-start print:hidden ${
                message?.type?.toLowerCase() === 'success' ? 'bg-success' : 'bg-error'
            }`}
        >
            <div className="p-1 md:p-2.5">
                <h1 className="text-base md:text-xl font-medium">
                    {message?.type?.toLowerCase() === 'success' ? 'Success' : 'Error'}
                </h1>
                <p className="font-normal text-sm md:text-base">{message?.text || message}</p>
            </div>
            <button
                type="button"
                onClick={handleClose}
                className="bg-inherit inline-flex border-0 border-solid text-white cursor-pointer "
            >
                <span className="inline-block bg-inherit text-white w-2.5 h-2.5">
                    <CrossIcon />
                </span>
            </button>
        </div>
    );
}

export default MessageTemplate;
